export * from './agreements.service';
import { AgreementsService } from './agreements.service';
export * from './articles.service';
import { ArticlesService } from './articles.service';
export * from './calendar.service';
import { CalendarService } from './calendar.service';
export * from './compartment.service';
import { CompartmentService } from './compartment.service';
export * from './customers.service';
import { CustomersService } from './customers.service';
export * from './diary.service';
import { DiaryService } from './diary.service';
export * from './healthCheck.service';
import { HealthCheckService } from './healthCheck.service';
export * from './inAppNotification.service';
import { InAppNotificationService } from './inAppNotification.service';
export * from './menu.service';
import { MenuService } from './menu.service';
export * from './messages.service';
import { MessagesService } from './messages.service';
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './orders.service';
import { OrdersService } from './orders.service';
export * from './pushNotification.service';
import { PushNotificationService } from './pushNotification.service';
export * from './serviceTypes.service';
import { ServiceTypesService } from './serviceTypes.service';
export * from './sites.service';
import { SitesService } from './sites.service';
export * from './wallets.service';
import { WalletsService } from './wallets.service';
export const APIS = [AgreementsService, ArticlesService, CalendarService, CompartmentService, CustomersService, DiaryService, HealthCheckService, InAppNotificationService, MenuService, MessagesService, NotificationsService, OrdersService, PushNotificationService, ServiceTypesService, SitesService, WalletsService];
